import {Button, Grid, TextField} from "@mui/material";
import {useState} from "react";
import {useAuth} from "../../../utils/FirebaseAuthContext";
import {useNavigate} from "react-router-dom";

const SignUpForm = () => {
    const [formState, setFormState] = useState({
        email: "",
        password: "",
        error: false,
        errorMessage: ""
    });
    const auth = useAuth();
    const navigate = useNavigate();

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setFormState({
            ...formState,
            [name]: value,
            error: false,
            errorMessage: ""
        });
    }

    const signUp = () => {
        if (formState.email.length === 0 || formState.password.length === 0) {
            return;
        }

        auth.signUp(formState.email, formState.password)
            .then(() => {
                navigate("/dashboard");
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode, errorMessage);
                setFormState({
                    ...formState,
                    error: true,
                    errorMessage: "Registrácia nebola úspešná"
                });
            });
    }

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            // signUp();
        }}>
            <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2}>
                <Grid item>
                    <TextField id="email" label="Emailová adresa" name="email" value={formState.email}
                               onChange={handleInputChange} variant="outlined" required type="email"/>
                </Grid>
                <Grid item>
                    <TextField id="password" label="Heslo" name="password" value={formState.password}
                               onChange={handleInputChange} variant="outlined" required type="password"
                               helperText={formState.errorMessage} error={formState.error}/>
                </Grid>
                <Grid item>
                    <Button type="submit" variant="contained">Registrovať sa</Button>
                </Grid>
            </Grid>
        </form>
    );
}

export default SignUpForm;
